import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { Breadcrumbs, Page } from 'components';
import { AnsweringServiceContextProvider } from './AnsweringServiceContext';
import AnsweringServiceLayout from './AnsweringServiceLayout';
import { ViewingLevel } from '../SubscriptionsPaymentsPage';

/** Breadcrumbs of previous pages to show at the top of the page */
const STATIC_BREADCRUMBS = [
  { breadcrumbName: 'Admin', path: '/admin' },
  { breadcrumbName: 'Live Concierge Service', path: '/answering_service/org' },
];

/**
 * The root page for a user to subscribe to Answering Service
 * (both Appointment Desk and Live Concierge) and to manage which
 * listings have Answering Service if they are already subscribed.
 *
 * AnsweringServiceLayout handles the internal content of the page.
 * There is both a version of the page for Brokerages accessible
 * through the Admin menu and a version for Users accesible through
 * the user menu. Brokers can access both depending which they navigate to.
 */
const AnsweringServicePage = ({
  viewingLevel,
}: {
  viewingLevel: ViewingLevel;
}) => {
  const history = useHistory();
  const { md } = useBreakpoint();

  const content = (
    <AnsweringServiceContextProvider
      viewingLevel={viewingLevel}
      billingRedirection={() =>
        history.push(`/subscriptions_payments/${viewingLevel}`)
      }
    >
      <AnsweringServiceLayout />
    </AnsweringServiceContextProvider>
  );

  return viewingLevel === 'org' ? (
    <Page
      overTitle={
        <StyledOverTitle>
          <Breadcrumbs breadcrumbRoutes={STATIC_BREADCRUMBS} />
        </StyledOverTitle>
      }
      title={md ? 'Live Concierge Service' : undefined}
      showBackButton={md}
      goBackUrl="/admin"
      type="hollow"
      extraTitleMargin
    >
      {content}
    </Page>
  ) : (
    <>{content}</>
  );
};

export default AnsweringServicePage;

const StyledOverTitle = styled.div`
  margin-bottom: 10px;
`;
